import { FC } from 'react';
import { CalculatorLayout } from '../../components/CalculatorLayout';
import { InputsSliderGroupContainer } from '../InputsSliderGroupContainer';
import { DownPaymentContainer } from '../DownPaymentContainer';
import { Header } from '../../components/Header';
import { PskGroupContainer } from '../PskGroupContainer';
import { Footer } from '../../components/Footer';

export const SubsidizedMortgageContainer: FC = () => {
  return (
    <CalculatorLayout
      header={<Header />}
      content={
        <>
          <InputsSliderGroupContainer />
          <DownPaymentContainer />
          <PskGroupContainer />
        </>
      }
      footer={<Footer />}
    />
  );
};
